import { memo } from 'react';
import cn from 'clsx';
import { LazyImage } from '@crehana/compass.ui';
import { usePlayroomRewardsTranslations } from "../../hooks";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var MarketplaceEmptyState = function MarketplaceEmptyState() {
  var _usePlayroomRewardsTr = usePlayroomRewardsTranslations(),
    t = _usePlayroomRewardsTr.t;
  var titleText = t('PRS_EMPTY_MARKETPLACE_TITLE');
  return /*#__PURE__*/_jsx("section", {
    className: cn('tw-text-center tw-py-1.6 tw-flex tw-flex-col tw-items-center',
    // Paddings
    'tw-py-2 md:tw-py-4.4'),
    "aria-label": titleText,
    children: /*#__PURE__*/_jsxs("div", {
      className: "tw-flex tw-flex-col tw-justify-center tw-items-center tw-h-full",
      children: [/*#__PURE__*/_jsx(LazyImage, {
        src: "https://crehana-vercel-images-prd.imgix.net/public/b5242d92-bf82-4ab5-87e8-a331f2222fb8-group-33167.png",
        alt: titleText,
        className: "tw-mb-2.4 tw-w-14.4 tw-h-14.4",
        isTransparent: true,
        imgClassName: "tw-object-cover",
        imgxParams: {
          w: 144,
          h: 144,
          q: 100,
          fit: 'clip'
        }
      }), /*#__PURE__*/_jsx("h5", {
        className: "tw-font-subtitle5 tw-mb-0.8",
        children: titleText
      })]
    })
  });
};
export default /*#__PURE__*/memo(MarketplaceEmptyState);